// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__dGu5a","item":"PaymentsMobile_item__3odxD","label":"PaymentsMobile_label__2YtwI","amount":"PaymentsMobile_amount__38UFq"};